// extracted by mini-css-extract-plugin
module.exports = {"card":"index_card_2WVnD","content":"index_content_22918","flag":"index_flag_1prni"};